import { getGoodsReportable } from './getGoodsReportable';
import { postGoodsReport } from './postGoodsReport';

export const reportService = {
  getGoodsReportable,
  postGoodsReport,
};